module.exports = __webpack_public_path__ + "img/facebook-logo.c97f0dd6.png";